<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M20,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6A2,2,0,0,0,20,4Zm0,4-8,5L4,8V6l8,5,8-5Z"
    />
    <path fill="none" d="M0,0H24V24H0Z" />
  </svg>
</template>

<script>
export default {
  name: "MailIcon",
};
</script>

<style scoped>
svg {
  width: 24px;
  height: 24px;
}
</style>
